import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import WallLanding from "./views/WallLanding";
import HotspotDetail from "./views/HotspotDetail";
import { initMixpanel, setupSessionEndTracking } from "./utils/mixpanel";

// Initialize Mixpanel
initMixpanel();
setupSessionEndTracking();

const router = createBrowserRouter([
  {
    path: "/",
    element: <WallLanding />,
  },
  {
    path: "/hotspot/:id",
    element: <HotspotDetail />,
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
